module.exports = __webpack_public_path__ + "static/img/BackgroundMultimodalTransportCollaboration_1.57a7270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/BackgroundMultimodalTransportCollaboration_1.png
// module id = f6C0
// module chunks = 44